/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelSegnalazioneAccountRowDTO } from '../model/models';
import { SegnalazioneAccountChiusuraForm } from '../model/models';
import { SegnalazioneAccountDTO } from '../model/models';
import { SegnalazioneAccountListFilter } from '../model/models';
import { SegnalazioneAccountNotaForm } from '../model/models';
import { SegnalazioneAccountPresaInCaricoForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AggiungiNotaSegnalazioneAccountRequestParams {
    id: string;
    segnalazioneAccountNotaForm: SegnalazioneAccountNotaForm;
}

export interface ChiudiSegnalazioneAccountRequestParams {
    id: string;
    segnalazioneAccountChiusuraForm: SegnalazioneAccountChiusuraForm;
}

export interface GetSegnalazioneAccountBackofficeRequestParams {
    id: string;
}

export interface ListSegnalazioniAccountBackofficeRequestParams {
    filter: SegnalazioneAccountListFilter;
    pageable: Pageable;
}

export interface PresaInCaricoSegnalazioneAccountRequestParams {
    id: string;
    segnalazioneAccountPresaInCaricoForm: SegnalazioneAccountPresaInCaricoForm;
}


export interface SegnalazioniAccountGestioneServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Aggiunge una nota allo storico di una segnalazione account (SUPERADMIN).
     * Non cambia lo stato e non richiede la version; ammessa in ogni stato.
     * @endpoint post /api/v1/gestione/segnalazioni-account/{id}/note
* @param requestParameters
     */
    aggiungiNotaSegnalazioneAccount(requestParameters: AggiungiNotaSegnalazioneAccountRequestParams, extraHttpRequestParams?: any): Observable<SegnalazioneAccountDTO>;

    /**
     * Chiude una segnalazione account con un esito (SUPERADMIN).
     * APERTA o IN_LAVORAZIONE -&gt; CHIUSA; esito obbligatorio. ACCOUNT_ABUSIVO_ANONIMIZZATO e\&#39; ammesso solo se l\&#39;account segnalato risulta gia\&#39; anonimizzato (o non esiste piu\&#39;): l\&#39;esito registra un fatto, non anonimizza.
     * @endpoint post /api/v1/gestione/segnalazioni-account/{id}/chiusura
* @param requestParameters
     */
    chiudiSegnalazioneAccount(requestParameters: ChiudiSegnalazioneAccountRequestParams, extraHttpRequestParams?: any): Observable<SegnalazioneAccountDTO>;

    /**
     * Dettaglio di una segnalazione account con storico (SUPERADMIN).
     * Include recapiti e testo del segnalante, l\&#39;account contestato (anonimizzato&#x3D;true anche se l\&#39;utente non esiste piu\&#39;) e gli eventi in ordine cronologico.
     * @endpoint get /api/v1/gestione/segnalazioni-account/{id}
* @param requestParameters
     */
    getSegnalazioneAccountBackoffice(requestParameters: GetSegnalazioneAccountBackofficeRequestParams, extraHttpRequestParams?: any): Observable<SegnalazioneAccountDTO>;

    /**
     * Lista paginata delle segnalazioni account (SUPERADMIN).
     * Filtri opzionali: stato, q (riferimento), da/a (data di creazione, estremi inclusi). Ordinamento predefinito createdAt desc, size 20. I recapiti e il testo del segnalante non sono nella lista, solo nel dettaglio.
     * @endpoint get /api/v1/gestione/segnalazioni-account
* @param requestParameters
     */
    listSegnalazioniAccountBackoffice(requestParameters: ListSegnalazioniAccountBackofficeRequestParams, extraHttpRequestParams?: any): Observable<PagedModelSegnalazioneAccountRowDTO>;

    /**
     * Prende in carico una segnalazione account (SUPERADMIN).
     * APERTA -&gt; IN_LAVORAZIONE. Richiede la version corrente.
     * @endpoint post /api/v1/gestione/segnalazioni-account/{id}/presa-in-carico
* @param requestParameters
     */
    presaInCaricoSegnalazioneAccount(requestParameters: PresaInCaricoSegnalazioneAccountRequestParams, extraHttpRequestParams?: any): Observable<SegnalazioneAccountDTO>;

}
